export const PUBLISH_CONTENT_TYPES = {
  BANNER: 'banner',
  TEMPLATE: 'template',
  PAGES: 'PAGES',
  CATEGORIES: 'CATEGORIES',
  WIDGETS: 'WIDGETS',
  SEO: 'SEO',
  INFORMATION_POLICY: 'INFORMATION_POLICY',
  ADMIN_SETTINGS: 'ADMIN_SETTINGS',
  CONFIG_SETTINGS: 'CONFIG_SETTINGS',
  GALLERY: 'GALLERY',
  OFFICIAL_CONTACT: 'OFFICIAL_CONTACT',
  ADMINISTRATION: 'ADMINISTRATION',
  PARISH_PRIEST: 'PARISH_PRIEST',
  LEADERSHIP_HISTORY: 'LEADERSHIP_HISTORY',
  HOUSE: 'HOUSE',
  HISTORY: 'HISTORY',
  HIERARCHY: 'HIERARCHY',
  CHURCH: 'CHURCH',
  ORGANIZATION: 'ORGANIZATION',
  MEMBERS: 'MEMBERS',
  CHAPEL: 'CHAPEL',
  NEWS: 'NEWS',
  FESTIVALS: 'FESTIVALS',
  ADVERTISEMENT: 'ADVERTISEMENT',
  OCCASION: 'OCCASION',
  LIVE_STREAMING: 'LIVE_STREAMING',
  INCOME_PDF_LINK: 'INCOME_PDF_LINK',
  EVENTS: 'EVENTS',
  QUOTES: 'QUOTES',
  POSITION: 'POSITION',
};
